import useIsDesktop from "@hooks/useIsDesktop"
import useUser from "@hooks/useUser"

import formatDate from "@utils/formatDate"
import isValidDate from "@utils/isValidDate"

import { ListItemStack } from "@molecules"
import ListItem from "@molecules/ListItem/ListItem"
import ListItemContent from "@molecules/ListItem/ListItemContent/ListItemContent"

import SetPasswordDialogsTrigger from "@pages/Settings/SettingsSecurityAndAccess/components/SetPasswordDialogsTrigger/SetPasswordDialogsTrigger"

export default function PasswordManagement() {
    const { user } = useUser()

    const lastUpdatedFormattedDate = isValidDate(user?.password_last_modified_at ?? null)
        ? formatDate({
              short: true,
              datetime: user?.password_last_modified_at ?? undefined,
              preferredTimezone: user?.service_company?.preferred_timezone,
              addYear: true,
          }).localDateString
        : null

    const subTitleCopy = user?.hasPassword
        ? lastUpdatedFormattedDate !== null
            ? `Last changed on ${lastUpdatedFormattedDate}`
            : "Last changed: Never"
        : "Secure your account with a password."

    const isDesktop = useIsDesktop()
    const orientation = isDesktop ? "horizontal" : "vertical"

    return (
        <ListItemStack>
            <ListItem.Root orientation={orientation}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={<ListItem.Label label="Password" />}
                            leftCaption={<ListItem.Caption caption={subTitleCopy} />}
                        />
                    }
                />
                <ListItem.Actions>
                    <SetPasswordDialogsTrigger />
                </ListItem.Actions>
            </ListItem.Root>
        </ListItemStack>
    )
}
